module.exports = __webpack_public_path__ + "img/4.a363de9f.png";